import {useLexicalComposerContext} from '@lexical/react/LexicalComposerContext';
import {COMMAND_PRIORITY_LOW} from 'lexical';
import {isMimeType, mediaFileReader} from '@lexical/utils';
import {DRAG_DROP_PASTE} from '@lexical/rich-text';
import {useEffect} from 'react';
import {INSERT_IMAGE_COMMAND} from './commands';
import {ACCEPTABLE_TYPES} from './constants';
import {checkImageSize} from '../../utils/checkHtmlSize';

export function DragDropPaste({
    isDraggable,
    shouldCheckSize = false,
    isValidImageType
}: {
    isDraggable?: boolean;
    shouldCheckSize?: boolean;
    isValidImageType?: (fileName: string) => boolean;
}): null {
    const [editor] = useLexicalComposerContext();

    useEffect(() => {
        return editor.registerCommand(
            DRAG_DROP_PASTE,
            files => {
                (async () => {
                    const filesResult = await mediaFileReader(files, ACCEPTABLE_TYPES);

                    for (const {file, result} of filesResult) {
                        const isBiggerThanMaxSize =
                            shouldCheckSize && checkImageSize(result, file.name, file.size);
                        const isValidType = isValidImageType ? isValidImageType(file.name) : true;
                        if (
                            !isBiggerThanMaxSize &&
                            isMimeType(file, ACCEPTABLE_TYPES) &&
                            isValidType
                        ) {
                            editor.dispatchCommand(INSERT_IMAGE_COMMAND, {
                                altText: file.name,
                                src: result,
                                isDraggable
                            });
                        }
                    }
                })();
                return true;
            },
            COMMAND_PRIORITY_LOW
        );
    }, [editor]);
    return null;
}
